import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg';
import * as Styled from './Alert.styled';

const Alert = (props) => {
  const {
    variant,
    children,
    classes,
    className,
    visible,
    onClose,
    dismissible,
    role,
  } = props;

  return (
    <Styled.Container
      hidden={!visible}
      role={role}
      className={classNames(classes.root, className)}
      variant={variant}>
      <div className={classes.textContainer}>{children}</div>
      {dismissible && (
        <Styled.DismissButton
          onClick={onClose}
          variant={'none'}
          className={classes.dismissIconButton}>
          <CloseIcon />
        </Styled.DismissButton>
      )}
    </Styled.Container>
  );
};

Alert.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    dismissIconButton: PropTypes.string,
    textContainer: PropTypes.string,
  }),
  className: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'error', 'warning']),
  dismissible: PropTypes.bool,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  role: PropTypes.string,
};

Alert.defaultProps = {
  variant: 'success',
  classes: {
    root: '',
    dismissIconButton: '',
    textContainer: '',
  },
  className: '',
  visible: true,
  onClose: () => {},
  dismissible: true,
  children: null,
  role: 'banner',
};

Alert.AlertMessage = Styled.AlertMessage;

export default Alert;
